import React from 'react';
import { DaySummaryRow, Summary, FirstCell, WOD, AllDay } from './style';
import { Text } from '../../../UI/Text';
import { BirthdaySummary } from './BirthdaySummary';
import { WorkoutOfTheDaySummary } from './WorkoutOfTheDaySummary';

export class DaySummary extends React.PureComponent {
    state = {
        width: window.innerWidth - 254,
    };

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({ width: window.innerWidth - 254 });
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    render() {
        const { width } = this.state;
        const {
            onToggleModal,
            weekSelected,
            workoutsOfTheDay,
            birthdays,
            toggleBirthdaysModal,
            columnWidth,
        } = this.props;
        const cellWidth = width / 7;
        const alternativeCellWidth = columnWidth.length > 0 ? columnWidth[0].width : null;

        return (
            <DaySummaryRow>
                <Summary width={`${width}px`}>
                    <FirstCell>
                        <WOD>
                            <Text fontSize={12} weight={100}>
                                WOD
                            </Text>
                        </WOD>
                    </FirstCell>

                    <WorkoutOfTheDaySummary
                        cellWidth={alternativeCellWidth || cellWidth}
                        columnDimensions={columnWidth}
                        weekSelected={weekSelected}
                        onToggleModal={onToggleModal}
                        workoutsOfTheDay={workoutsOfTheDay}
                    />
                </Summary>

                <Summary height={'40px'} width={`${width}px`}>
                    <FirstCell height={'40px'}>
                        <AllDay>
                            <Text fontSize={12} weight={100}>
                                All day
                            </Text>
                        </AllDay>
                    </FirstCell>

                    <BirthdaySummary
                        cellWidth={alternativeCellWidth || cellWidth}
                        columnDimensions={columnWidth}
                        weekSelected={weekSelected}
                        birthdays={birthdays}
                        toggleBirthdaysModal={toggleBirthdaysModal}
                    />
                </Summary>
            </DaySummaryRow>
        );
    }
}



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/Calendar/DaySummary.js